var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"score-histogram"},[(_vm.chartData)?_c('bar-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"height":300}}):_c('p',[_vm._v("Loading score distribution...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }